import * as React from 'react';

import config from 'js/app/config';

import { TrackedA } from 'bundles/page/components/TrackedLink2';
import LinkTag from 'bundles/seo/components/LinkTag';

type Props = {
  skill: string;
};

export const SeoSkillsLinkTag = ({ skill }: Props) => {
  const encodedSkill = encodeURIComponent(skill.toLowerCase());
  const href = `${config.url.base}courses?query=${encodedSkill}`;

  return (
    <LinkTag href={href} component={TrackedA} trackingName="seo_skills_link_tag" data={{ skill }}>
      {skill}
    </LinkTag>
  );
};

export default SeoSkillsLinkTag;
